function initGoogleReviews() {
    const container = document.querySelector('.google-reviews-section');
    if (!container) return;

    const placeId = container.dataset.placeId;
    const target = document.getElementById('google-reviews-target');
    const totalEl = document.getElementById('google-reviews-total');

    if (!placeId) {
        if (target) target.innerHTML = '<p style="text-align:center; width:100%;">Please provide a valid Google Place ID in the section settings.</p>';
        return;
    }

    // We need a dummy DOM element to instantiate PlacesService (it doesn't need to be visible)
    const mapDiv = document.createElement('div');
    const service = new google.maps.places.PlacesService(mapDiv);

    service.getDetails({
        placeId: placeId,
        fields: ['name', 'rating', 'reviews', 'user_ratings_total', 'url']
    }, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {

            // Update the total reviews and average rating with a link to Google Maps
            if (totalEl) {
                const avgRating = place.rating ? `${place.rating} ★ ` : '';
                const totalReviews = place.user_ratings_total ? `(${place.user_ratings_total} Google Reviews)` : '';
                
                // Use the official place URL if available, otherwise construct a fallback search URL
                const mapUrl = place.url || `https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${placeId}`;
                
                totalEl.innerHTML = `<a href="${mapUrl}" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: underline;">${avgRating}${totalReviews}</a>`;
            }

            if (place.reviews && place.reviews.length > 0) {
                renderReviews(place.reviews);
                initCarouselControls();
            } else {
                if (target) target.innerHTML = '<p style="text-align:center; width:100%;">No reviews found for this location.</p>';
            }

        } else {
            if (target) target.innerHTML = '<p style="text-align:center; width:100%;">Could not load reviews at this time. Please check your API key and Place ID.</p>';
            if (totalEl) totalEl.textContent = 'Reviews unavailable';
            console.error('Google Places Service Status:', status);
        }
    });
}

function renderReviews(reviews) {
    const target = document.getElementById('google-reviews-target');
    if (!target) return;

    target.innerHTML = ''; // Clear loading text

    // Google Places API returns max 5 reviews.
    // To populate the carousel nicely, we'll duplicate the array to reach 15 comments.
    let duplicatedReviews = [];
    while (duplicatedReviews.length < 15) {
        duplicatedReviews = duplicatedReviews.concat(reviews);
    }

    // Trim to exactly 15 if needed
    duplicatedReviews = duplicatedReviews.slice(0, 15);

    // Build the HTML for the reviews
    const reviewsHTML = duplicatedReviews.map(review => {
        const stars = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
        return `
            <div class="review-card">
              <div class="review-header">
                <img class="review-author-img" src="${review.profile_photo_url || 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png'}" alt="${review.author_name}" width="40" height="40" loading="lazy">
                <div class="review-author">
                  <strong>${review.author_name}</strong>
                  <div class="review-rating" style="color: #fbbc04;">${stars}</div>
                </div>
              </div>
              <p class="review-text">${review.text.length > 150 ? review.text.substring(0, 150) + '...' : review.text}</p>
              <div class="review-time"><small>${review.relative_time_description}</small></div>
            </div>
        `;
    }).join('');

    target.innerHTML = reviewsHTML;
}

function initCarouselControls() {
    const target = document.getElementById('google-reviews-target');
    const leftBtn = document.getElementById('gr-scroll-left');
    const rightBtn = document.getElementById('gr-scroll-right');

    if (!target || !leftBtn || !rightBtn) return;

    // Scroll amount: Width of card (320) + gap (20)
    const scrollAmount = 340;

    leftBtn.addEventListener('click', () => {
        target.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightBtn.addEventListener('click', () => {
        target.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
}

// Attach init function to global scope so Google Maps callback can find it
window.initGoogleReviews = initGoogleReviews;